import { useStore } from 'app/context';
import { AgenturModel } from 'app/models/agentur.model';
import { BranchenplanungPosDef } from 'app/models/branchenplanung/bp.pos.def';
import { AgtBpVM } from 'app/stores/ui/agt.branchenplanung.ui.store';
import { formatPercentTwoDig } from 'app/utils';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import { useState, useEffect } from 'react';
import { EditableBpField, OtherBpFieldValues, RingValue } from './AgtBranchenplanungEdit';

interface IBpKeysEditor {
	agt: AgenturModel;
	year: number;
	bpKeys: string[];
	editMode: boolean;
}

export const AgtBranchenplanungKeysField = observer((props: IBpKeysEditor) => {
	const { agtBranchenplanungUiStore } = useStore();
	const [data, setData] = useState<AgtBpVM>();
	const [initialValues, setInitialValues] = useState<any>();

	useEffect(() => {
		agtBranchenplanungUiStore.findByYearAndAgtId(props.year, props.agt.agtId).then((d) => {
			if (!d) {
				d = agtBranchenplanungUiStore.createEmptyBP(props.agt, props.year);
			}
			setData(d);

			// Store initial values for change detection
			const initial: any = {};
			props.bpKeys.forEach((key) => {
				initial[key] = (d as any)[key];
			});
			setInitialValues(initial);
		});
	}, [agtBranchenplanungUiStore, props.year, props.agt.agtId, props.bpKeys]);

	const { values, setFieldValue } = useFormikContext<any>();

	// Sync BP data changes to Formik
	useEffect(() => {
		if (data && initialValues) {
			props.bpKeys.forEach((key) => {
				const currentValue = (data as any)[key];
				if (!values[key]) {
					setFieldValue(key, currentValue || '');
				}
			});
		}
	}, [data, initialValues, props.bpKeys, values, setFieldValue]);

	const visiblePosDefs = BranchenplanungPosDef.filter((p) => props.bpKeys.includes(p.planKey));

	if (!data) {
		return <div>Laden...</div>;
	}

	return (
		<div className="bp-keys-editor">
			<div className="table-container is-boxed">
				<table className="table">
					<thead>
						<tr>
							<th>Branchenplanung</th>
							<th>Meine Planung</th>
							<th>Ziele</th>
							<th>GP/Ring Ziel</th>
							<th>Ergebnis</th>
							<th>Meine ZE</th>
							<th>ZE Zeit</th>
						</tr>
					</thead>
					<tbody>
						{visiblePosDefs.map((bpPosDef) => {
							const fak = agtBranchenplanungUiStore.currentUmrechnungsFaktor;
							const einheit = bpPosDef.getEinheitForFak(fak);

							return (
								<tr key={bpPosDef.prop}>
									<td>
										<strong>{bpPosDef.posText}</strong>
									</td>
									<td>
										<EditableBpField posDef={bpPosDef} einheit={einheit} editMode={props.editMode} />
									</td>
									<td>
										<OtherBpFieldValues posDef={bpPosDef} data={data} />
									</td>

									<td>
										<RingValue planKey={bpPosDef.planKey} data={data.ringZiel} />
									</td>
									<td>
										<RingValue planKey={bpPosDef.planKey} data={data.ringErgebnis} />
									</td>
									<td>
										<RingValue planKey={bpPosDef.planKey} data={data.ringZE} format={formatPercentTwoDig} />
									</td>

									<td>
										<RingValue planKey={bpPosDef.planKey} data={data.ringZEZeit} format={formatPercentTwoDig} />
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
});
